import { Goal, GoalProgressCount, ID } from '@griply/types';

import { getGoalAchievedPercentage } from './get-goal-achieved-percentage';

export const hasGoalReachedTarget = (
  goal: Goal,
  goals: Goal[],
  goalProgressCounts?: Map<ID, GoalProgressCount>,
): boolean =>
  (getGoalAchievedPercentage(goal, goals, goalProgressCounts) ?? 0) >= 100;
